<template>
    <div v-if="hasNavigated">
        <nav class="md:mt-28 bg-secondary w-full tac fixed pin-t pin-x z-30 px-4 md:px-2">
            <div class="mx-auto relative max-w-3xl text-center h-10 flex justify-center items-center">
                <router-link :to="goto" tag="a"
                             class="h-full items-center flex bg-secondary absolute
                              pin-t pin-l pr-1 text-white font-bold font-heading
                               uppercase hover:text-white back-button">
                    <i class="fal fa-chevron-left mr-2"></i>
                    Back
                </router-link>

                <slot></slot>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        goto: {
            type: String,
            default: '/'
        }
    },

    computed: {
        hasNavigated() {
            return this.$route.path !== '/';
        }
    }
}
</script>
<style>
.back-button, .back-button:hover {
    text-decoration: none;
}
</style>
